import { ChevronDown } from 'lucide-react';
import { clsx } from 'clsx';

interface SwitchToggleProps {
  selected: boolean;
  onToggle: () => void;
  children: React.ReactNode;
  /** Pleine largeur : le libellé prend l'espace, le switch se cale à droite. */
  block?: boolean;
  /** Ajoute un chevron (indique que la bascule OUVRE du contenu). */
  chevron?: boolean;
  disabled?: boolean;
  className?: string;
}

/**
 * Interrupteur à bascule.
 *
 * Contrairement à `OptionToggle` (qui SÉLECTIONNE un élément parmi d'autres),
 * `SwitchToggle` ACTIVE/RÉVÈLE une fonction : budget temporaire, montants par
 * semaine… Le glissement du pouce porte l'état ; le chevron optionnel signale
 * qu'un contenu se déploiera. `role="switch"` + `aria-checked` pour l'accessibilité.
 */
export default function SwitchToggle({
  selected,
  onToggle,
  children,
  block = false,
  chevron = false,
  disabled = false,
  className,
}: SwitchToggleProps) {
  return (
    <button
      type="button"
      role="switch"
      aria-checked={selected}
      disabled={disabled}
      onClick={onToggle}
      className={clsx('switch-row', block && 'block', selected && 'on', disabled && 'opacity-50 cursor-not-allowed', className)}
    >
      <span className="s-txt">{children}</span>
      {chevron && <ChevronDown className="s-chev w-4 h-4" />}
      <span className="switch-track" aria-hidden />
    </button>
  );
}
